module.exports = __webpack_public_path__ + "static/media/Inclined-Kids6.5ac87931.jpg";